import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { AvInput, AvFeedback, AvGroup } from 'availity-reactstrap-validation';
import { Label } from 'reactstrap';

import { creditCardExpirationPattern, inputCreditCardNumberPattern, creditCardCvcPattern } from 'js/services/Regex';

import CreditCardInput from './CreditCardInput';
import SecurityCodeExplanation from './SecurityCodeExplanation';
import TwoColumnGrid from './TwoColumnGrid';
import CardValid from "js/components/common/CreditCardForm/CardValid";
import AddressInput from 'js/components/common/AddressInput';
import AddressFeedback from 'js/components/common/AddressInput/AddressFeedback';
import { validCreditCard } from 'js/services/Regex';

@inject('page')
@observer
export default class CreditCardForm extends Component {
  hasClearedNumber = false;

  componentDidMount() {
    if(this.props.creditCard
      && this.props.creditCard.number
      && this.props.creditCard.number.toUpperCase().startsWith("XXXX")) {
      this.clearNumber();
    }
  }

  clearNumber = () => {
    if (!this.hasClearedNumber) {
      this.props.creditCard.setNumber('');
      this.hasClearedNumber = true;
    }
  };

  render() {
    const { creditCard, labels, legend } = this.props;

    return (
      <>
        <AvGroup>
          {labels !== false && <Label for="name">Name on Card</Label>}
          <AvInput
            type="text"
            name="name"
            id="name"
            placeholder={labels === false ? 'Name on card' : ''}
            autoComplete="cc-name"
            value={creditCard.name}
            onChange={creditCard.setName}
            required
          />
          <AvFeedback>Please enter your name as it appears on the card.</AvFeedback>
        </AvGroup>

        <AvGroup>
          {labels !== false && <Label for="number">Card Number</Label>}
          <CreditCardInput
            legend={legend}
            type="tel"
            name="number"
            id="credit-card-number"
            placeholder={labels === false ? 'Card number' : ''}
            autoComplete="cc-number"
            value={creditCard.number}
            onChange={creditCard.setNumber}
            onKeyUp={creditCard.checkIfCCNumberIsValid}
            maxLength={creditCard.cc_type === 'amex' ? 17 : 19}
            required
            validate={{
              tel: { pattern: inputCreditCardNumberPattern },
            }}
            onFocus={this.clearNumber}
            cardType={creditCard.cc_type}
          />
          {validCreditCard(creditCard.number) && <CardValid />}
          <AvFeedback>Please enter your credit card number.</AvFeedback>
        </AvGroup>

        <TwoColumnGrid>
          <AvGroup>
            {labels !== false && <Label for="expire">Expiry Date</Label>}
            <AvInput
              type="tel"
              name="expire"
              id="expire"
              placeholder={labels === false ? 'Expiry (MM/YY)' : ''}
              autoComplete="cc-exp"
              value={creditCard.expire}
              onChange={creditCard.setExpire}
              maxLength={7}
              required
              validate={{ tel: { pattern: creditCardExpirationPattern } }}
            />
            <AvFeedback>Required.</AvFeedback>
          </AvGroup>
          <AvGroup>
            {labels !== false && <Label for="cvc">Security Code</Label>}
            <AvInput
              type="tel"
              name="cvc"
              id="cvc"
              autoComplete="cc-csc"
              value={creditCard.cvc}
              onChange={creditCard.setCvc}
              required
              validate={{
                tel: { pattern: creditCardCvcPattern },
              }}
              placeholder={labels === false ? 'CVC' : ''}
            />
            <AvFeedback>Required.</AvFeedback>
            <SecurityCodeExplanation minimal={labels === false} cardType={creditCard.cc_type}/>
          </AvGroup>
        </TwoColumnGrid>

        <AvGroup>
          {labels !== false && <Label for="address">Billing Address</Label>}
          <AddressInput
            name="address"
            showError={creditCard.hasAddressError}
            address={creditCard.address}
            onChange={creditCard.address.setAddress}
            placeholder="Billing Address associated with this card"
            flat={!creditCard.showShippingSelection}
          />
          <AddressFeedback>Please enter and then select your address.</AddressFeedback>
        </AvGroup>
      </>
    );
  }
}
